<template>
    <b-modal v-model="showModal" title="Pagar partes restantes" no-close-on-backdrop no-close-on-esc hide-footer
        scrollable size="xl">
        <b-input-group prepend="Username" class="mb-4 mt-2">
            <template #prepend>
                <b-form-select v-model="typeFilter" :options="options"></b-form-select>
            </template>
            <b-form-input v-model="textSearch"></b-form-input>
            <b-input-group-append>
                <b-button variant="primary" @click="search()" :disabled="disabledSearch">Buscar</b-button>
            </b-input-group-append>
        </b-input-group>
        <b-table striped borderless hover :items="items" :fields="fields" v-if="items.length">
            <template #cell(transaction)="data">
                {{ data.item.transaction }} <br>
                <span><strong>Fecha:</strong></span> {{ data.item.paymentDate | date }} <br>
                <span><strong>Hora:</strong></span> {{ data.item.paymentDate | hours }} <br>
            </template>
            <template #cell(actions)="data">
                <button class="btn btn-outline-dark btn-block mb-2" @click="viewQuotas(data.item)">
                    Ver pagos
                </button>
            </template>
        </b-table>
        <div class="resultSearch" v-if="msjResult !== '' && !loading && textSearch.length > 2">
            No se encontraron resultados
        </div>
        <p class="resultSearch" v-if="loading">
            <b-spinner small></b-spinner>
        </p>
    </b-modal>
</template>
<script>
import api from '../../api';
import ls from '../../ls';
import moment from 'moment';
export default {
    props: {
        eventId: {
            type: Number,
        }
    },
    watch: {
        textSearch(value) {
            if (value.length > 2) {
                this.search();
                this.disabledSearch = false;
            } else {
                this.disabledSearch = true;
            }
        }
    },
    filters: {
        date(value) {
            return moment(value, 'DD-MM-YYYY hh:mm:ss').format("DD/MM/YYYY")
        },
        hours(value) {
            return moment(value, 'DD-MM-YYYY hh:mm:ss').format("hh:mm:ss")
        }
    },
    data() {
        return {
            loading: false,
            showModal: false,
            textSearch: '',
            typeFilter: 'email',
            options: [
                { value: 'email', text: 'Correo' },
                { value: 'names', text: 'Nombre' },
                { value: 'document', text: 'Nro documento' },
                { value: 'transaction', text: 'Transacción' }
            ],
            //table
            fields: [
                { key: 'firstName', label: 'Nombres' },
                { key: 'lastName', label: 'Apellidos' },
                { key: 'documentType', label: 'Tipo documento' },
                { key: 'document', label: 'Documento' },
                { key: 'email', label: 'Correo' },
                { key: 'transaction', label: 'Transacción' },
                { key: 'actions', label: 'Acciones' },
            ],
            items: [],
            msjResult: '',
            disabledSearch: true,
        }
    },
    methods: {
        show() {
            this.showModal = true
        },
        hide() {
            this.showModal = false;
            this.textSearch = '';
            this.resetValues();

        },
        search() {
            if (this.textSearch.trim() && this.textSearch) {
                const data = {
                    type: this.typeFilter,
                    value: this.textSearch
                }
                this.transactionByParams(data)
            }
        },
        async transactionByParams(params) {
            try {
                this.disabledSearch = true;
                this.loading = true;
                this.items = [];
                const transaction = await api.getTransactionByParams(this.eventId, params)
                if (transaction.status) {
                    this.items = transaction.data
                    if (this.items.length === 0) {
                        this.msjResult = 'No se encontraron resultados.'
                    } else {
                        this.msjResult = ''
                    }
                } else {
                    this.items = []
                    this.msjResult = 'No se encontraron resultados.'
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.resetValues()
            }
        },
        viewQuotas(data) {
            this.$store.dispatch('setUserFeePayment', data);
            this.$router.push({ name: 'Payment', params: { ticketId: data.transaction } });
            this.$store.dispatch('setEventId', this.eventId);
            this.setSessionStoreUserPayments(data, this.eventId)
            this.$store.dispatch('changeIsCreateFeePayment', false);
        },
        resetValues() {
            this.disabledSearch = false;
            // this.textSearch = '';
            this.loading = false;
            ls.removeItem('fp-user');
        },
        setSessionStoreUserPayments(user, eventId) {
            const data = {
                user: user,
                eventId: eventId
            }
            ls.setItem('fp-user', JSON.stringify(data));
        }
    }
}
</script>
<style scoped lang="scss">
.resultSearch {
    margin: 1rem 0;
    text-align: center;
    font-weight: 600;
}
</style>